// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2HgOL","row":"Node_row__1LFRs","label":"Node_label__DX12S","footer":"Node_footer__NfgsT"};